import React, {useCallback, useContext, useState} from 'react';

import {MessageContext} from 'src/contexts/message-context';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';

import {useDeleteSsoSettings} from '../hooks/useDeleteSsoSettings';

type Props = {
    onClose: () => void,
    accountId: number,
    onDeleted: () => void,
};

export const DeleteSsoSettingsModal = ({onClose, accountId, onDeleted}: Props) => {
    const {setSuccessMessage} = useContext(MessageContext);
    const [serverError, setServerError] = useState<string | undefined>(undefined);
    const {event, busy} = useDeleteSsoSettings({
        accountId,
        onSuccess: () => {
            setSuccessMessage('Account SSO Settings is successfully deleted');
            onClose();
            onDeleted();
        },
        onFail: setServerError,
    });
    const onRemove = useCallback(() => {
        event();
    }, [event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Delete SSO Settings
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {serverError ? <Message color="error">{serverError}</Message> : null}
                Are you sure you want to delete Account SSO Settings?

                Please note - settings will be deleted only from this account.
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button variant="Type.PRIMARY" busy={busy} onClick={onRemove}>
                        Delete
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
